export default __webpack_public_path__ + "static/media/Food_06.c39deefc.png";